(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["b2b-category-grid"] && !Shopify.designMode) return;
  try {
    
  (() => {
    let scrollFrame = 0;
    document.addEventListener('click', (event) => {
      const trigger = event.target.closest?.('[data-b2b-open-header-search]');
      if (!trigger || !document.body.classList.contains('b2b-customer')) return;
      window.cancelAnimationFrame(scrollFrame);
      const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      window.scrollTo({ top: 0, behavior: reducedMotion ? 'instant' : 'smooth' });
      const started = performance.now();
      const visibleInput = () => [...document.querySelectorAll('header input[type="search"]')]
        .find((input) => input.getClientRects().length && getComputedStyle(input).visibility !== 'hidden');
      const revealSearch = () => {
        if (window.scrollY > 2 && performance.now() - started < 1500) {
          scrollFrame = window.requestAnimationFrame(revealSearch);
          return;
        }
        if (window.scrollY > 2) window.scrollTo({ top: 0, behavior: 'instant' });
        let input = visibleInput();
        if (!input) {
          document.querySelector('header .header__search details > summary')?.click();
          input = visibleInput();
        }
        if (input) {
          input.focus({ preventScroll: true });
          input.click();
        }
      };
      scrollFrame = window.requestAnimationFrame(revealSearch);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
if (!customElements.get('ppa-footer-menus')) {
  customElements.define('ppa-footer-menus', class extends HTMLElement {
    connectedCallback() {
      this.abortController?.abort();
      this.abortController = new AbortController();
      const signal = this.abortController.signal;
      this.media = window.matchMedia('(max-width: 749px)');
      this.menus = Array.from(this.querySelectorAll('[data-footer-accordion]'));
      this.mobileStates = new Map(this.menus.map(menu => [menu, this.dataset.mobileOpen === 'true']));
      this.sync = () => {
        this.menus.forEach(menu => {
          const summary = menu.querySelector('summary');
          menu.open = this.media.matches ? this.mobileStates.get(menu) : true;
          summary.tabIndex = this.media.matches ? 0 : -1;
        });
      };
      this.menus.forEach(menu => {
        menu.addEventListener('toggle', () => {
          if (this.media.matches) this.mobileStates.set(menu, menu.open);
        }, { signal });
        menu.querySelector('summary').addEventListener('click', event => {
          if (!this.media.matches) event.preventDefault();
        }, { signal });
      });
      this.media.addEventListener('change', this.sync, { signal });
      document.addEventListener('shopify:block:select', event => {
        const menu = this.menus.find(item => item.contains(event.target) || event.target.contains(item));
        if (menu && this.media.matches) {
          this.mobileStates.set(menu, true);
          menu.open = true;
        }
      }, { signal });
      this.sync();
    }
    disconnectedCallback() {
      this.abortController?.abort();
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-OD"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();
      this.setHeaderSearchMargin();

      window.matchMedia('(max-width: 1499px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.onResizeHandler = this.onResize.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);
      window.addEventListener('resize', this.onResizeHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    setHeaderSearchMargin() {
      const headerSearch = this.header.querySelector('.header__search');
      const headerIcons = this.header.querySelector('.header__icons');

      if (headerSearch && headerIcons) {
        headerSearch.style.setProperty('--header-icons-width', `${headerIcons.offsetWidth + 122}px`);
      }
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
      window.removeEventListener('resize', this.onResizeHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onResize() {
      this.setHeaderSearchMargin();
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');

        if (this.preventHide) return;

        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');

        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;

      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;

      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;

      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');

      if (this.searchModal) this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["packpoints-intro"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (window.packpointsRewardEmptyStateInitialised) return;
    window.packpointsRewardEmptyStateInitialised = true;

    const observedRewardRoots = new WeakSet();

    const initialiseEmptyRewards = () => {
      document.querySelectorAll('[id*="dotdigital_loyalty_redeemed_rewards_section_"]').forEach((block) => {
        if (block.dataset.packpointsEmptyState === 'initialised') return;

        const wrapper = block.querySelector('.rewards-wrapper');
        if (!wrapper) return;

        block.dataset.packpointsEmptyState = 'initialised';
        let attempts = 0;

        const updateEmptyState = () => {
          const rewardHost = wrapper.querySelector('reward-list');
          const shadowRoot = rewardHost && rewardHost.shadowRoot;
          const isLoading = shadowRoot && shadowRoot.querySelector('.loading, [aria-busy="true"]');
          const rewards = rewardHost && Array.isArray(rewardHost._rewards) ? rewardHost._rewards : [];
          const renderedRewards = shadowRoot ? shadowRoot.querySelectorAll('.reward-item').length : 0;

          if (shadowRoot && !observedRewardRoots.has(shadowRoot)) {
            observedRewardRoots.add(shadowRoot);
            new MutationObserver(updateEmptyState).observe(shadowRoot, {
              childList: true,
              subtree: true,
              attributes: true,
              attributeFilter: ['aria-busy', 'class']
            });
          }

          if (!rewardHost || !shadowRoot || isLoading) return;

          const existing = wrapper.querySelector('.packpoints-rewards-empty');
          if (rewards.length > 0 || renderedRewards > 0) {
            existing?.remove();
            block.classList.remove('packpoints-rewards--empty');
            return;
          }

          if (existing) return;

          const emptyState = document.createElement('div');
          emptyState.className = 'packpoints-rewards-empty';
          emptyState.setAttribute('role', 'status');
          emptyState.innerHTML = '<span class="packpoints-rewards-empty__icon" aria-hidden="true"><svg viewBox="0 0 32 32"><path d="M5 13h22v14H5zM16 13v14M4 9h24v4H4zM16 9c-5 0-7-1.7-7-4 0-1.4 1.1-2.5 2.5-2.5C14.5 2.5 16 9 16 9Zm0 0s1.5-6.5 4.5-6.5C21.9 2.5 23 3.6 23 5c0 2.3-2 4-7 4Z" fill="none" stroke="currentColor" stroke-width="2.1" stroke-linejoin="round"/></svg></span><div><strong>No rewards ready to use yet</strong><p>Redeem PackPoints below and your reward will appear here for checkout.</p></div>';
          wrapper.appendChild(emptyState);
          block.classList.add('packpoints-rewards--empty');
        };

        new MutationObserver(updateEmptyState).observe(wrapper, { childList: true, subtree: true });
        const loadingTimer = window.setInterval(() => {
          updateEmptyState();
          attempts += 1;
          if (attempts >= 40) window.clearInterval(loadingTimer);
        }, 500);
        updateEmptyState();
      });
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initialiseEmptyRewards, { once: true });
    } else {
      initialiseEmptyRewards();
    }

    window.setTimeout(initialiseEmptyRewards, 1200);
    window.setTimeout(initialiseEmptyRewards, 3500);
    document.addEventListener('shopify:section:load', initialiseEmptyRewards);
  })();

  (() => {
    if (window.packpointsMemberDashboardInitialised) return;
    window.packpointsMemberDashboardInitialised = true;

    const observedShadowRoots = new WeakSet();

    const setText = (element, value) => {
      if (element && value && element.textContent !== value) element.textContent = value;
    };

    const parsePoints = (value) => {
      if (typeof value === 'number' && Number.isFinite(value)) return value;
      if (typeof value !== 'string') return Number.NaN;
      const match = value.match(/[\d,]+/);
      return match ? Number(match[0].replace(/,/g, '')) : Number.NaN;
    };

    const getRewardCatalogue = (host) => {
      if (!host || !host.shadowRoot) return [];

      const rewards = [];
      const addReward = (name, points) => {
        const cleanName = typeof name === 'string' ? name.trim().replace(/^(\d+)\s*AUD\b/i, '$1 AUD') : '';
        const cleanPoints = parsePoints(points);
        if (!cleanName || !Number.isFinite(cleanPoints)) return;
        if (rewards.some((reward) => reward.name === cleanName && reward.points === cleanPoints)) return;
        rewards.push({ name: cleanName, points: cleanPoints });
      };

      if (Array.isArray(host._rewards)) {
        host._rewards.forEach((reward) => {
          addReward(
            reward.name || reward.title || reward.rewardName || reward.label,
            reward.pointsRequired || reward.requiredPoints || reward.pointsCost || reward.points || reward.cost
          );
        });
      }

      host.shadowRoot.querySelectorAll('.reward-item').forEach((item) => {
        const name = item.querySelector('.reward-header, [class*="reward-header"], h3, h4')?.textContent;
        const pointsText = item.querySelector('.reward-subheader, [class*="reward-subheader"]')?.textContent || item.textContent;
        const pointsMatch = pointsText && pointsText.match(/[\d,]+\s*(?:Pack)?Points?/i);
        addReward(name, pointsMatch ? pointsMatch[0] : pointsText);
      });

      return rewards.sort((left, right) => left.points - right.points);
    };

    const addShadowStyle = (host, id, rules) => {
      if (!host || !host.shadowRoot) return;
      let style = host.shadowRoot.querySelector('#' + id);
      if (!style) {
        style = document.createElement('style');
        style.id = id;
        style.textContent = rules;
        host.shadowRoot.appendChild(style);
      }
    };

    const observeShadow = (host, callback) => {
      if (!host || !host.shadowRoot || observedShadowRoots.has(host.shadowRoot)) return;
      observedShadowRoots.add(host.shadowRoot);
      new MutationObserver(callback).observe(host.shadowRoot, { childList: true, subtree: true });
    };

    const initialiseDashboard = (dashboard) => {
      if (dashboard.dataset.packpointsDashboard === 'initialised') return;
      dashboard.dataset.packpointsDashboard = 'initialised';

      const appSection = document.querySelector('[id$="__apps_Qde6bn"]');
      if (!appSection) return;

      const balanceValue = dashboard.querySelector('[data-packpoints-balance]');
      const balanceStatus = dashboard.querySelector('[data-packpoints-balance-status]');
      const rewardValue = dashboard.querySelector('[data-packpoints-reward]');
      const rewardStatus = dashboard.querySelector('[data-packpoints-reward-status]');
      const tierValue = dashboard.querySelector('[data-packpoints-tier]');
      const nextTierValue = dashboard.querySelector('[data-packpoints-next-tier]');
      const progress = dashboard.querySelector('[data-packpoints-progress]');
      const progressLabel = dashboard.querySelector('[data-packpoints-progress-label]');

      const sync = () => {
        const memberHost = appSection.querySelector('[id*="dotdigital_loyalty_member_details_"] member-details');
        const memberHeader = appSection.querySelector('[id*="dotdigital_loyalty_member_details_"] [id^="main-header-"]');
        const headerBalance = memberHeader && memberHeader.textContent.match(/[\d,]+/);
        const memberBalance = memberHost && memberHost.memberDetails
          ? Number(memberHost.memberDetails.currentPointsBalance)
          : headerBalance
            ? Number(headerBalance[0].replace(/,/g, ''))
            : Number.NaN;

        if (Number.isFinite(memberBalance)) {
          setText(balanceValue, new Intl.NumberFormat('en-AU').format(memberBalance));
          setText(balanceStatus, 'Live balance from your PackPoints account');
        }

        const redeemedHost = appSection.querySelector('[id*="dotdigital_loyalty_redeemed_rewards_section_"] reward-list');
        if (redeemedHost && redeemedHost.shadowRoot) {
          addShadowStyle(redeemedHost, 'packpoints-reward-cards', [
            '.reward-list{gap:18px!important;margin-top:22px!important;padding:4px!important;}',
            '.reward-item{box-sizing:border-box;min-width:0;padding:18px;background:#fff;border:1px solid #e0e4e6;border-radius:16px;box-shadow:0 8px 22px rgba(31,41,51,.06);overflow:hidden;}',
            '.image-container{box-sizing:border-box;width:100%!important;margin:0 0 14px!important;padding:12px!important;border-radius:12px;overflow:hidden;}',
            '.reward-header{margin:0!important;color:#1f2933!important;font-weight:750!important;}'
          ].join(''));
          observeShadow(redeemedHost, sync);
        }

        const rewardCatalogue = appSection.querySelector('[id*="dotdigital_loyalty_rewards_section_"] reward-list');
        if (rewardCatalogue && rewardCatalogue.shadowRoot) {
          const catalogue = getRewardCatalogue(rewardCatalogue);
          if (Number.isFinite(memberBalance) && catalogue.length) {
            const affordable = catalogue.filter((reward) => reward.points <= memberBalance).pop();
            if (affordable) {
              setText(rewardValue, affordable.name);
              setText(rewardStatus, 'Redeem ' + new Intl.NumberFormat('en-AU').format(affordable.points) + ' PackPoints for this reward at checkout');
            } else {
              const nextReward = catalogue[0];
              const pointsNeeded = Math.max(0, nextReward.points - memberBalance);
              setText(rewardValue, 'Next: ' + nextReward.name);
              setText(rewardStatus, new Intl.NumberFormat('en-AU').format(pointsNeeded) + ' more PackPoints needed');
            }
          }

          addShadowStyle(rewardCatalogue, 'packpoints-reward-cards', [
            '.reward-list{gap:18px!important;margin-top:22px!important;padding:4px!important;}',
            '.reward-item{box-sizing:border-box;min-width:0;padding:18px;background:#fff;border:1px solid #e0e4e6;border-radius:16px;box-shadow:0 8px 22px rgba(31,41,51,.06);overflow:hidden;}',
            '.image-container{box-sizing:border-box;width:100%!important;margin:0 0 14px!important;padding:12px!important;border-radius:12px;overflow:hidden;}',
            '.reward-header{margin:0!important;color:#1f2933!important;font-weight:750!important;}'
          ].join(''));
          observeShadow(rewardCatalogue, sync);
        }

        const tierHost = appSection.querySelector('[id*="dotdigital_loyalty_tier_progress_section_"] tiers-progress-section');
        if (tierHost && tierHost.shadowRoot) {
          const details = tierHost.tierDetails;
          const currentTier = details && details.currentTier ? details.currentTier.name : tierHost.shadowRoot.querySelector('.current-tier')?.textContent?.trim();
          const nextTier = details && details.nextTier ? details.nextTier.name : tierHost.shadowRoot.querySelector('.next-tier')?.textContent?.trim();
          const summary = tierHost.shadowRoot.querySelector('.move-to-next-level')?.textContent?.trim();

          if (currentTier) setText(tierValue, currentTier);
          setText(nextTierValue, nextTier ? 'Next: ' + nextTier : 'Highest tier reached');
          if (summary) setText(progressLabel, summary);

          const sourceProgress = tierHost.shadowRoot.querySelector('progress');
          if (sourceProgress && progress) {
            const max = Number(sourceProgress.max) || 1;
            const value = Math.min(Number(sourceProgress.value) || 0, max);
            const percentage = Math.max(0, Math.min(100, Math.round((value / max) * 100)));
            progress.style.setProperty('--packpoints-progress', percentage + '%');
            progress.setAttribute('aria-valuenow', String(percentage));
          }

          addShadowStyle(tierHost, 'packpoints-tier-progress', [
            '.tiers-progress-content{box-sizing:border-box;align-items:stretch!important;padding:24px;background:#fff!important;border:1px solid #dfe3e5;border-radius:18px;box-shadow:0 10px 26px rgba(31,41,51,.06);text-align:left!important;}',
            'h2{text-align:left!important;}',
            '.subheader{text-align:left!important;font-weight:700;margin-bottom:20px!important;}',
            '.tier-details{width:100%!important;}',
            '.progress{height:16px!important;}',
            '.move-to-next-level{margin:18px 0 0!important;padding:12px 14px!important;}'
          ].join(''));
          observeShadow(tierHost, sync);
        }

        if (memberHost && memberHost.shadowRoot) {
          addShadowStyle(memberHost, 'packpoints-activity-table', [
            '.table-title h3{margin:0 0 16px;color:#1f2933;font-size:2.4rem;line-height:1.15;}',
            '.member-activity-table-container{box-sizing:border-box;background:#fff;border:1px solid #dfe3e5;border-radius:16px;box-shadow:0 8px 22px rgba(31,41,51,.05);overflow:auto;}',
            'table{min-width:620px;}',
            'th,td{padding:11px 16px!important;}',
            '.member-activity-pagination{margin:0;padding:14px;border-top:1px solid #e2e4e5;}',
            '.point-expiry{margin:0 0 16px!important;}'
          ].join(''));
          observeShadow(memberHost, sync);
        }

        const tiersHost = appSection.querySelector('[id*="dotdigital_loyalty_tiers_table_section_"] tiers-table-section');
        if (tiersHost && tiersHost.shadowRoot) {
          addShadowStyle(tiersHost, 'packpoints-tier-cards', [
            '.tiers-table-content{background:transparent!important;text-align:left!important;}',
            '.table-intro-header{text-align:left!important;padding-bottom:12px!important;}',
            '.tiers-table{column-gap:12px!important;margin-top:12px!important;min-width:820px;}',
            '.tiers-table th,.tiers-table td{box-sizing:border-box;padding:10px 14px!important;background:#fff;}',
            '.tiers-table tr:first-of-type th:not(.table-intro-header){min-height:58px;justify-content:center!important;text-align:center!important;background:#1f2933!important;color:#fff!important;border:0!important;border-radius:14px 14px 0 0;}',
            '.tiers-table tr:first-of-type th:first-child{background:transparent!important;}',
            '[scope="row"]:not(.table-intro-header){background:transparent!important;padding-top:9px!important;padding-bottom:9px!important;}',
            'tr:not(:first-of-type) [scope="col"]{background:transparent!important;padding:20px 0 8px!important;}',
            '.tiers-table td{border-bottom:1px solid #e2e4e5!important;}'
          ].join(''));
          observeShadow(tiersHost, sync);
        }
      };

      new MutationObserver(sync).observe(appSection, { childList: true, subtree: true });
      sync();

      let attempts = 0;
      const loadingTimer = window.setInterval(() => {
        sync();
        attempts += 1;
        if (attempts >= 80) window.clearInterval(loadingTimer);
      }, 400);

      const liveBalanceTimer = window.setInterval(() => {
        if (!dashboard.isConnected) {
          window.clearInterval(liveBalanceTimer);
          return;
        }
        sync();
      }, 5000);
    };

    const initialiseAllDashboards = () => {
      document.querySelectorAll('.packpoints-dashboard').forEach(initialiseDashboard);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initialiseAllDashboards, { once: true });
    } else {
      initialiseAllDashboards();
    }

    document.addEventListener('shopify:section:load', initialiseAllDashboards);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-feature"] && !Shopify.designMode) return;
  try {
    
	window.addEventListener('DOMContentLoaded', () => {
		const blogProductMentionLink = document.getElementById('article-template__link-to-featured-product');
		const blogProductMentionContainer = document.getElementById('blog-article__featured-product');

		if (blogProductMentionLink && blogProductMentionContainer) {
			blogProductMentionLink.classList.remove('hidden');

			blogProductMentionLink.addEventListener('click', (e) => {
				e.preventDefault();
				window.scrollTo({
					top: blogProductMentionContainer.offsetTop,
					left: 0,
					behavior: 'smooth'
				});
			});
		}
	});

  } catch(e) { console.error(e); }
})();
})();
